import StatusBadge from '../common/StatusBadge';
import { useNavigate } from 'react-router-dom';
import './PlanTable.css';

export default function PlanTable({
  plans,
  view,
  onToggleView,
  onOpenPreview,
  onOpenResult,
  currentPage = 1,
  totalPages = 1,
  onPageChange = () => {},
}) {
  const navigate = useNavigate();
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="plan-table-card">
      <div className="plan-table-header">
        <div>
          <h3>Plans soumis</h3>
          <p className="muted">Liste complète de vos plans de cours</p>
        </div>
        <div className="view-toggle">
          <button
            type="button"
            className={view === 'list' ? 'active' : ''}
            onClick={() => onToggleView('list')}
            aria-label="Vue liste"
          >
            ☰
          </button>
          <button
            type="button"
            className={view === 'grid' ? 'active' : ''}
            onClick={() => onToggleView('grid')}
            aria-label="Vue grille"
          >
            ⬚
          </button>
        </div>
      </div>

      {view === 'list' ? (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Titre du plan</th>
                <th>Cours</th>
                <th>Chef d'équipe</th>
                <th>Statut</th>
                <th>Soumission</th>
                <th>PDF</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan) => (
                <tr key={plan.id}>
                  <td className="title">{plan.title}</td>
                  <td>{plan.course}</td>
                  <td>{plan.chef}</td>
                  <td>
                    <StatusBadge status={plan.status} />
                  </td>
                  <td>
                    <div className="date-block">
                      <span>{plan.submittedAt}</span>
                      <span className="muted">Maj: {plan.lastUpdated}</span>
                    </div>
                  </td>
                  <td>
                    <span className="pdf-status">{plan.pdfStatus}</span>
                  </td>
                  <td>
                    <div className="action-stack">
                      {plan.pdfUrl && plan.pdfUrl !== '#' ? (
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => onOpenPreview(plan)}
                        >
                          Visualiser
                        </button>
                      ) : (
                        <span className="muted">—</span>
                      )}
                      <button
                        type="button"
                        className="view-btn view-grid-btn"
                        onClick={() => navigate(`/grid/${plan.id}`)}
                      >
                        📋 Voir grille
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="grid-view">
          {plans.map((plan) => (
            <article key={plan.id} className="plan-card">
              <h4>{plan.title}</h4>
              <p className="muted">{plan.course}</p>
              <StatusBadge status={plan.status} />
              <div className="meta">
                <span>Soumis le {plan.submittedAt}</span>
                <span>Maj {plan.lastUpdated}</span>
              </div>
              <div className="card-actions">
                {plan.pdfUrl && plan.pdfUrl !== '#' ? (
                  <button
                    type="button"
                    className="view-btn"
                    onClick={() => onOpenPreview(plan)}
                  >
                    Visualiser
                  </button>
                ) : (
                  <span className="pdf-status">{plan.pdfStatus}</span>
                )}
                <button
                  type="button"
                  className="view-btn view-grid-btn"
                  onClick={() => navigate(`/grid/${plan.id}`)}
                >
                  📋 Voir grille
                </button>
              </div>
            </article>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button type="button" onClick={handlePrevious} disabled={currentPage === 1}>
            &lt; Previous
          </button>
          {pageNumbers.map((page) => (
            <button
              key={page}
              type="button"
              className={page === currentPage ? 'page active-page' : 'page'}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          ))}
          <button type="button" onClick={handleNext} disabled={currentPage === totalPages}>
            Next &gt;
          </button>
        </div>
      )}
    </div>
  );
}
